<template>
  <div class="fengji-pop-content">
    <div class="title">{{ number }}风机信息</div>

    <div class="jingdu-weidu-area">
      <el-form
        ref="form"
        :rules="uploadrules"
        :model="uploadForm"
        label-width="50px"
      >
        <el-form-item label="经度" prop="lon">
          <el-input v-model="uploadForm.lon"></el-input>
        </el-form-item>
        <el-form-item label="纬度" prop="lat">
          <el-input v-model="uploadForm.lat"></el-input>
        </el-form-item>
        <el-form-item label="高度" prop="height">
          <el-input v-model="uploadForm.height"></el-input>
        </el-form-item>
        <el-form-item label="机型" prop="turbineTypeId">
          <el-select v-model="uploadForm.turbineTypeId">
            <el-option
              v-for="(item, index) in turList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <div class="btn-wrapper">
      <el-button v-if="showCancel" type="text" @click="handleBackClick"
        >回到原处</el-button
      >
      <el-button type="text" @click="handleSaveClick">保存</el-button>
      <el-button type="text" @click="handleDelClick">删除</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'turbineTypeId',
    'lat',
    'lon',
    'height',
    'turList',
    'id',
    'afterSave',
    'afterDel',
    'hasDrag',
    'back',
    'windfarmId',
    'turbineType',
    'number'
  ],

  created() {
    const item = this.turList.find(item => item.label === this.turbineType);

    if (!item) {
      this.uploadForm.turbineTypeId = this.turbineType;
    } else {
      this.uploadForm.turbineTypeId = this.turbineTypeId;
    }

    this.uploadForm.lat = this.lat;
    this.uploadForm.lon = this.lon;
    this.uploadForm.height = this.height;
    this.turbineId = this.id;
  },

  computed: {
    showCancel() {
      return !!this.hasDrag;
    }
  },

  data() {
    return {
      uploadrules: {
        turbineTypeId: [
          { required: true, message: '请选择风机类型', trigger: 'change' }
        ],
        lat: [{ required: true, message: '请输入纬度', trigger: 'change' }],
        lon: [{ required: true, message: '请输入经度', trigger: 'change' }],
        height: [{ required: true, message: '请输入高度', trigger: 'change' }]
      },
      turbineId: '',
      uploadForm: {
        turbineTypeId: '',
        lat: '',
        lon: '',
        height: ''
      }
    };
  },
  methods: {
    handleSaveClick() {
      this.$refs.form.validate(valid => {
        const item = this.turList.find(
          i => i.value === this.uploadForm.turbineTypeId
        );

        if (!item) {
          return this.$message.warning(
            `机型${this.uploadForm.turbineTypeId}已经从机型库删除，请重新选择机型`
          );
        }

        if (valid) {
          this.$postForm('/windfarm/windfarm/fanGroupCheck', {
            data: {
              lats: this.uploadForm.lat,
              lons: this.uploadForm.lon,
              turbineTypeId: this.uploadForm.turbineTypeId,
              turbineIds: this.turbineId,
              windfarmId: this.windfarmId
            },
            showLoading: true,
            noJudge: true
          }).then(re => {
            const { data } = re;

            const { code, message } = data;
            if (code == 0) {
              this.$postForm('/windfarm/windfarm/updateWindfarmTurbine', {
                data: {
                  ...this.uploadForm,
                  turbineId: this.turbineId
                },
                showLoading: true,
                showSuccess: true,
                showError: true
              }).then(() => {
                this.afterSave && this.afterSave(this.uploadForm);
              });
            } else if (code == 2) {
              this.$confirm(message, '提醒', {
                confirmButtonText: '继续保存',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnClickModal: false
              }).then(() => {
                this.$postForm('/windfarm/windfarm/updateWindfarmTurbine', {
                  data: {
                    ...this.uploadForm,
                    turbineId: this.turbineId
                  },
                  showLoading: true,
                  showSuccess: true,
                  showError: true
                }).then(() => {
                  this.afterSave && this.afterSave(this.uploadForm);
                });
              });
            } else if (code == 1) {
              return this.$message.error(message);
            } else {
              return this.$message.error(message);
            }
          });
        }
      });
    },
    handleDelClick() {
      this.$confirm('是否删除该风机', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.$postForm('/windfarm/windfarm/deleteWindfarmTurbine', {
          data: {
            turbineId: this.turbineId
          },
          showError: true,
          showSuccess: true
        }).then(() => {
          this.afterDel && this.afterDel(this.turbineId);
        });
      });
    },
    handleBackClick() {
      this.back && this.back();
    }
  }
};
</script>

<style lang="less" scoped>
.fengji-pop-content {
  color: #000;
  width: 260px;
  .title {
    margin-bottom: 15px;
    font-weight: 600;
    font-size: 14px;
  }

  .btn-wrapper {
    text-align: right;
  }

  .jingdu-weidu-area {
    display: flex;
    align-items: center;
    &:not(:first-child) {
      margin-top: 10px;
    }
    .row-item {
      display: flex;
      align-items: center;
      .key {
        font-size: 14px;
        width: 60px;
        margin-right: 5px;
      }
      &:first-child {
        margin-right: 10px;
      }
    }
  }

  .jixing-area {
    margin-top: 10px;
    display: flex;
    align-items: center;
    .key {
      width: 60px;
      margin-right: 5px;
      font-size: 14px;
    }
  }

  .btn-wrapper {
    text-align: right;
  }
}
</style>
